
// export const BASE_URL = 'https://gsdapi.foxberry.link/v1';
//  export const BASE_URL_FOXBERRY =  'http://localhost:9001/v1';
//  export const BASE_URL = 'http://localhost:9001/v1';
 export const BASE_URL_FOXBERRY =  'https://tms-api.foxberry.live/v1';
 export const BASE_URL = 'https://tms-api.foxberry.live/v1';



